export default __webpack_public_path__ + "static/media/superwarm_v_skiff_.5a168cbe.jpg";